import { createAuthorizedFetcher } from "../features/auth/createAuthorizedFetcher";

export async function apiFetch(url, a, b) {
  // support both apiFetch(url, token, opts) and apiFetch(url, { token, ... })
  const isLegacy = typeof a === "string" || typeof a === "number";
  const token = isLegacy ? a : a?.token;
  const options = (isLegacy ? b : a) || {};
  const { onUnauthorized, authScheme, ...fetchOptions } = options;

  const fetcher = createAuthorizedFetcher(token, onUnauthorized, {
    requireToken: false,
    authScheme,
  });

  const res = await fetcher(url, fetchOptions);
  const text = await res.text();
  let data = null;
  try { data = text ? JSON.parse(text) : null; } catch { /* non-JSON */ }

  if (!res.ok) {
    const msg = data?.detail || data?.error || data?.message || `HTTP ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    err.payload = data;
    throw err;
  }
  return data ?? {};
}

export async function downloadFile(url, token, filename = "orders.csv") {
  const res = await fetch(url, {
    headers: {
      Authorization: `Token ${token}`,
      Accept:
        "text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, */*;q=0.8",
    },
    credentials: "include",
  });
  if (!res.ok) throw new Error("Failed to download the file.");
  const blob = await res.blob();
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename; document.body.appendChild(a); a.click(); a.remove();
}
